import { authenticatedGet, authenticatedPost, authenticatedDelete } from "../../api/authenticatedFetch";

const BASE = "/api/v1/invoice-inbound-tokens";

// listInboundTokens returns this customer's inbound tokens (masked, newest first). Never contains secrets.
export const listInboundTokens = async () => {
  const res = await authenticatedGet(BASE);
  return res?.inbound_tokens ?? [];
};

// createInboundToken mints an inbound token. The response carries the one-time secret under `inbound_token`.
export const createInboundToken = async (label) => {
  const res = await authenticatedPost(BASE, { label });
  return res?.inbound_token ?? res;
};

// revokeInboundToken revokes an inbound token by id. Response is the updated (revoked) token under `inbound_token`.
export const revokeInboundToken = async (id) => {
  const res = await authenticatedDelete(`${BASE}/${id}`);
  return res?.inbound_token ?? res;
};
